module.exports = __webpack_public_path__ + "assets/Deepbite selected.fbfe7952471f3c97591dd9695f3e332a.png";